import axios from 'axios'
import {
  LaundryConfigDaysColumn,
  LaundryConfigDaysDto,
  LaundryConfigDaysFilter,
  ResponseCRUD,
  ResponseObject,
  ResponseObjectPaginated,
} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_LAVANDERIA_URL

export function getLaundryConfigDays(dto: LaundryConfigDaysFilter, page: number) {
  return axios.post<ResponseObjectPaginated<LaundryConfigDaysFilter[]>>(
    `${BASEURL}/configuration/getAllSettingsScheduledDate/${page}`,
    dto,
  )
}

export function getLaundryConfigDaysById(dto: string | undefined) {
  return axios.get<ResponseObject<LaundryConfigDaysColumn>>(
    `${BASEURL}/configuration/getSettingsScheduledDateById?id=${dto}`,
  )
}
export function createLaundryConfigDays(dto: LaundryConfigDaysDto) {
  return axios.post<ResponseCRUD>(`${BASEURL}/configuration/createSettingsScheduledDate`, dto)
}
export function updateLaundryConfigDays(dto: LaundryConfigDaysDto) {
  return axios.put<ResponseCRUD>(`${BASEURL}/configuration/updateSettingsScheduledDate`, dto)
}

export function deleteLaundryConfigDays(dto: any) {
  return axios.delete<ResponseCRUD>(
    `${BASEURL}/configuration/deleteSettingsScheduledDate?id=${dto}`,
  )
}
